import React, { useState, useRef } from "react";
import  "./heroMobile.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";

import FaceSwapHero from "./../faceSwapHero";
import ImgInhancerHero from "./../imgInhancerHero";
import ImgGeneratorHero from "./../imgGeneratorHero";
import { allRoutes } from "@/data/allRoutes";

export default function HeroMobile({ setShowCommingSoonModal }) {
  const [displayCard, setDisplayCard] = useState("faceswap");
  const swiperRef = useRef(null);

  // change cards
  /*  useEffect(() => {
    const intervalId = setInterval(() => {
      switch (displayCard) {
        case "faceswap":
          setDisplayCard("enhancer");
          break;
        case "enhancer":
          setDisplayCard("generator");
          break;
        case "generator":
          setDisplayCard("faceswap");
          break;
        default:
          setDisplayCard("faceswap");
          break;
      }
    }, 5000); 

    return () => clearInterval(intervalId);
  }, [displayCard]);*/

  const handleTitleClick = (card) => {
    setDisplayCard(card);

    // Navigate to the corresponding Swiper slide

    const swiper = swiperRef.current;
    if (swiper) {
      const slideIndex = {
        faceswap: 0,
        enhancer: 1,
        generator: 2,
      }[card];
      swiper.slideTo(slideIndex);
    }
  };

  return (
    <div className="HeroMobile">
      <div className="flex-col-center heroMobileTop" >
        {displayCard === "faceswap" && (
          <h1 className={"grd-txt"}>AI Face Swap </h1>
        )}
        {displayCard === "enhancer" && (
          <h1 className={"grd-txt"}>AI Image Enhancer</h1>
        )}
        {displayCard === "generator" && (
          <h1 className={"grd-txt"}>AI Image Generator </h1>
        )}

        {displayCard === "faceswap" && (
          <p className="txt1 description">
            AI-powered face swap
            <br />
            Express yourself with freedom !
          </p>
        )}

        {displayCard === "enhancer" && (
          <p className="txt1 description">
            Experience Seamless Image Enhancer Online. Turn Your Photos into Fun
            Creations Instantly !
          </p>
        )}

        {displayCard === "generator" && (
          <p className="txt1 description">
            Experience Seamless Image Generate Online. Turn Your Photos into Fun
            Creations Instantly !
          </p>
        )}
      </div>

      {/* cards Mobile */}
      <div className="cardsMobile">
        <div className="flex-row-center title">
          <p
            onClick={() => handleTitleClick("faceswap")}
            className={`text textUnique ${
              displayCard === "faceswap" ? "titleUnderline" : ""
            }`}
          >
            Face Swap
          </p>
          <p
            onClick={() => handleTitleClick("enhancer")}
            className={`text ${
              displayCard === "enhancer" ? "titleUnderline" : ""
            }`}
          >
            AI Image Enhancer
          </p>
          <p
            onClick={() => handleTitleClick("generator")}
            className={`text ${
              displayCard === "generator" ? "titleUnderline" : ""
            }`}
          >
            AI Image Generator
          </p>
        </div>
        <div className="changeCard">
          {/*  {displayCard === "faceswap" && (
            <FaceSwapHero setDisplayCard={setDisplayCard} />
          )}

          {displayCard === "enhancer" && (
            <ImgInhancerHero setDisplayCard={setDisplayCard} />
          )}

          {displayCard === "generator" && (
            <ImgGeneratorHero setDisplayCard={setDisplayCard} />
          )} */}

          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            /*  autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }} */
            spaceBetween={50}           slidesPerView={1}
            className="flex-row-center swiper"
            onSwiper={(swiper) => (swiperRef.current = swiper)} // Save swiper instance
            onSlideChange={(swiper) => {
              // Update `displayCard` when the slide changes
              const activeIndex = swiper.activeIndex;
              const card = ["faceswap", "enhancer", "generator"][activeIndex];
              setDisplayCard(card);
            }}
          >
            <SwiperSlide className="flex-row-center swiperSlide">
              <FaceSwapHero
                setDisplayCard={setDisplayCard}
                path={allRoutes?.faceSwap}
              />
            </SwiperSlide>

            <SwiperSlide className="flex-row-center swiperSlide">
              <ImgInhancerHero
                setDisplayCard={setDisplayCard}
                setShowCommingSoonModal={setShowCommingSoonModal}
                path={allRoutes?.imageEnhancer}
              />
            </SwiperSlide>

            <SwiperSlide className="flex-row-center swiperSlide">
              <ImgGeneratorHero
                setDisplayCard={setDisplayCard}
                setShowCommingSoonModal={setShowCommingSoonModal}
                path={allRoutes?.imageGenerator}
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
}
